export const TABLE_COLUMNS = [
    {
        Header: <div className="flex justify-center">Nombre</div>,
        accessor: 'name'
    },
    {
        Header: <div className="flex justify-center">Tipo de Impresión</div>,
        accessor: 'printing_type'
    },
    {
        Header: <div className="flex justify-center">Documento</div>,
        accessor: 'actions'
    }
]

// Single source of truth lives in utils/orderUtils so the print-decision helper
// and this table share the same printing-type values.
export { DOCUMENT_TYPES } from "../../../../../utils/orderUtils"
